import React from 'react';
import './spinner.css';
import { Backdrop, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectLoading } from '../../../redux/loading/loading.actions';

const Spinner = () => {
  const isLoading = useSelector(selectLoading);
  console.log('isLoading', isLoading);


  return (
    <Backdrop
      open={isLoading}
      sx={{
        zIndex: 9999,
        backgroundColor: 'rgba(250, 250, 249, 0.72)',
        color: 'var(--text-muted)',
      }}
    >
      <CircularProgress size={40} thickness={4} sx={{ color: 'var(--accent)' }} />
    </Backdrop>
  );
}

export default Spinner;
